<modal-component>

	<!-- LEFT-->
	<ng-container left>
		<div class="_header">
			<p *ngIf="action === 'create'" class="_title" [translate]="(eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.CREATE' : 'EVENT.LESSONS.CREATE_ALL')"></p>
			<p *ngIf="action === 'update'" class="_title" [translate]="(eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.EDIT' : 'EVENT.LESSONS.EDIT_ALL')"></p>
			<p class="_subtitle">{{eventForm?.get('name').value}}</p>	
		</div>	

		<div class="_info _new-event" >
			<p [translate]="'EVENT.ATTENDANCE_DETAILS'"></p>



			<div class="_walkin">
				<ion-icon src="./assets/icons/door.svg"></ion-icon>
				<b [translate]="'EVENT_ATTENDANCE_TYPE.WALKIN'"></b>
				<p [translate]="'EVENT_ATTENDANCE_TYPE.WALKIN_INFO'"></p>
			</div>

			<div class="_reservation">
				<ion-icon src="./assets/icons/user-outline.svg"></ion-icon>
				<b [translate]="'EVENT_ATTENDANCE_TYPE.RESERVATION'"></b>
				<p [translate]="'EVENT_ATTENDANCE_TYPE.RESERVATION_INFO'"></p>
			</div>

			<div class="_registration">
				<ion-icon src="./assets/icons/employees-outline.svg"></ion-icon>
				<b [translate]="'EVENT_ATTENDANCE_TYPE.REGISTRATION'"></b>
				<p [translate]="'EVENT_ATTENDANCE_TYPE.REGISTRATION_INFO'"></p>
			</div>

			<div class="_lesson">
				<ion-icon src="./assets/icons/education-outline.svg"></ion-icon>
				<b [translate]="'EVENT_ATTENDANCE_TYPE.LESSONS'"></b>
				<p [translate]="'EVENT_ATTENDANCE_TYPE.LESSONS_INFO'"></p>
			</div>

		</div>
	</ng-container>

	
	<!-- RIGHT -->
	<ng-container right>
		<form [formGroup]="eventForm">
			
			<!-- DETAILS -->
			<p class="_title" [translate]="'EVENT.WHAT'"></p>
			<form-input label="{{ 'EVENT.NAME' | translate }}" [formControl]="eventForm.get('name') | cast"></form-input>

			<form-select label="{{ 'EVENT.TYPE' | translate }}" [formControl]="eventForm.get('EventTypeId') | cast" [items]="eventTypes" bindValue="id" bindLabel="name" [multiple]="false">
				<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]" add-button>
					<button class="_button _add-button" (click)="createEventType()">
						<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
					</button>
				</ng-container>
			</form-select>

			<form-select label="{{ 'EVENT.DIGIBANK_AGENCY' | translate }}" [formControl]="eventForm.get('DigibankAgencyId') | cast" [items]="agencies" bindValue="id" bindLabel="name" [multiple]="false">
				<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]" add-button>
					<button class="_button _add-button" (click)="createDigibankAgency()">
						<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
					</button>
				</ng-container>
			</form-select>

			<form-select label="{{ 'EVENT.DIGIBANK_OBJECTIVE.TITLE' | translate }}" [formControl]="eventForm.get('digibankObjective') | cast" [items]="digibankObjectives" bindValue="value" bindLabel="label" [multiple]="false">
			</form-select>			

			<!-- ATTENDANCE -->
			<p class="_title" [translate]="'EVENT.ATTENDANCE_DETAILS'"></p>
			
			<form-radio label="{{ 'EVENT.ATTENDANCE_TYPE' | translate }}" [formControl]="eventForm.get('attendanceType') | cast" [items]="eventAttendanceTypes" bindValue="value" bindLabel="label"></form-radio>

			<ng-container *ngIf="eventForm.get('attendanceType').value === EventAttendanceType.Reservation">
				<form-number label="{{ 'EVENT.RESERVATION_INTERVAL' | translate }}" [formControl]="eventForm.get('reservationInterval') | cast" ></form-number>
			</ng-container>

			<ng-container *ngIf="eventForm.get('attendanceType').value === EventAttendanceType.Registration || eventForm.get('attendanceType').value === EventAttendanceType.Lessons">
				<form-number 
					label="{{ (eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.MAX_REGISTRATIONS' : 'EVENT.LESSONS.MAX_REGISTRATIONS') | translate }}" 
					[formControl]="eventForm.get('maxRegistrations') | cast" 
				></form-number>
			</ng-container>	
			
			<!-- PLANNING LESSONS -->
			<div *ngIf="eventForm.get('attendanceType').value === EventAttendanceType.Lessons" class="_lessons-block">
				<p class="_title" [translate]="'EVENT.PLANNING_DETAILS'">
					{{'EVENT.PLANNING_DETAILS' | translate}} 
					<span *ngIf="eventForm.get('Lessons').value?.length === 1">
						({{'EVENT.LESSONS.ONE_LESSON_PLANNED' | translate}})
					</span>
					<span *ngIf="eventForm.get('Lessons').value?.length !== 1">
						({{eventForm.get('Lessons').value ? eventForm.get('Lessons').value?.length : 0}} {{'EVENT.LESSONS.LESSONS_PLANNED' | translate}})
					</span>
				</p>

				<div *ngFor="let lesson of eventForm.get('Lessons').value" class="_lessons">
					<div class="_lesson" (click)="createOrEditLesson(lesson)">
						<p class="_label">
							<b *ngIf="lesson.name">{{lesson.name}}: </b>{{lesson.CalendarEvent.startsAt | date:"EEEE dd/MM/yyyy"}} | {{lesson.CalendarEvent.startsAt | date:"HH:mm"}} - {{lesson.CalendarEvent.endsAt | date:"HH:mm"}}
							<br>
							<span class="_description" *ngIf="lesson.description">{{lesson.description}}</span>
						</p>
					</div>
				</div>

				<button class="_button _save-button" [translate]="'EVENT.LESSONS.CREATE'" (click)="createOrEditLesson()"></button>
				<form-validation-error [control]="eventForm.get('Lessons') | cast"></form-validation-error>
			</div>
			

			<!-- PLANNING REGISTRATIONS / RESERVATION / WALK-IN -->
			<ng-container *ngIf="eventForm.get('attendanceType').value !== EventAttendanceType.Lessons">
				<p class="_title" [translate]="'EVENT.PLANNING_DETAILS'"></p>

				<div class="_formcontrol-with-validation">
					<form-date 
						label="{{ (!eventForm.get('interval').value || eventForm.get('interval').value === EventInterval.OneTime ? 'EVENT.STARTS_AT' : 'EVENT.STARTS_AT_INTERVAL') | translate }}" [formControl]="eventForm.get('startsAt') | cast">
					</form-date>
					<form-validation-error [control]="eventForm | cast"></form-validation-error>
				</div>

				
				<div class="_start-end-time">
					<form-time label="{{'EVENT.START_TIME' | translate }}" [formControl]="eventForm.get('startTime') | cast"></form-time>
					<form-time label="{{'EVENT.END_TIME' | translate }}" [formControl]="eventForm.get('endTime') | cast"></form-time>
				</div>

				<form-select 
					label="{{ 'EVENT.INTERVAL' | translate }}" [formControl]="eventForm.get('interval') | cast" [items]="eventIntervals" bindValue="value" bindLabel="label" [multiple]="false">
				</form-select>

				<div class="_custom-interval" *ngIf="eventForm.get('interval').value === EventInterval.Custom">
					<div class="_interval-inputs">
						<p [translate]="'EVENT_INTERVAL.CUSTOM_INTERVAL.TITLE'"></p>

						<input [formControl]="eventForm.get('customIntervalNumber') | cast" type="number" inputmode="numeric"/>
		
						<form-select 
							[formControl]="eventForm.get('customIntervalType') | cast" [items]="customIntervalTypes" bindValue="value" bindLabel="label" [multiple]="false">
						</form-select>
					</div>

					<div class="_interval-validators">
						<form-validation-error [control]="eventForm.get('customIntervalNumber') | cast"></form-validation-error>
						<form-validation-error [control]="eventForm.get('customIntervalType') | cast"></form-validation-error>
					</div>
				</div>		

				<div class="_formcontrol-with-validation" *ngIf="eventForm.get('interval').value && eventForm.get('interval').value !== EventInterval.OneTime">
					<form-date label="{{ 'EVENT.ENDS_AT'| translate }}" [formControl]="eventForm.get('intervalEndsAt') | cast"></form-date>
					<form-validation-error [control]="eventForm | cast"></form-validation-error>
				</div>
			</ng-container>



			<!-- LOCATION -->
			<p class="_title" [translate]="(eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.LOCATION' : 'EVENT.LESSONS.LOCATION')"></p>

			<form-select 
				label="{{ 'EVENT.EVENT_LOCATION_TYPE' | translate }}" [formControl]="eventForm.get('locationType') | cast" [items]="eventLocationTypes" bindValue="value" bindLabel="label" [multiple]="false">
			</form-select>

			<ng-container *ngIf="eventForm.get('locationType').value === EventLocationType.OnLocation">
				<form-select label="{{ 'EVENT.SELECT_LOCATION' | translate }}" [formControl]="eventForm.get('LocationId') | cast" [items]="locations" bindLabel="place" [multiple]="false" [template]="template">
					<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]" add-button>
						<button class="_button _add-button" (click)="createLocation()">
							<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
						</button>
					</ng-container>
					<ng-template let-item #template> 
						<div class="_location">
							<p class="_place">{{item.place}}</p>
							<p class="_address">{{item.Address | address}}</p>
						</div>
					</ng-template>
				</form-select>
			</ng-container>

			<ng-container *ngIf="eventForm.get('locationType').value === EventLocationType.Online">
				<form-textarea label="{{ 'EVENT.URL' | translate }}" [formControl]="eventForm.get('url') | cast"></form-textarea>
			</ng-container>

			<!-- EXTRA INFO -->
			<p class="_title" [translate]="'EVENT.EXTRA'"></p>		
			<form-textarea label="{{ 'EVENT.DESCRIPTION' | translate }}" [formControl]="eventForm.get('description') | cast"></form-textarea>

			<form-input label="{{ 'COMMUNICATION.REPLY_TO' | translate }}" [formControl]="eventForm.get('replyTo') | cast"></form-input>

			<form-input label="{{ 'COMMUNICATION.TELEPHONE' | translate }}" [formControl]="eventForm.get('telephone') | cast"></form-input>

			<form-select label="{{ 'EVENT.EMPLOYEES' | translate }}" [formControl]="eventForm.get('Employees') | cast" [items]="employees" bindValue="id" [multiple]="true" [template]="employeesTemplate">
				<ng-template let-item #employeesTemplate> 
					<div class="_employees">
						<p>{{item.firstname}} {{item.lastname}}</p>
						<p class="_employee-info" *ngIf="item.DigibankAgency?.name || item.jobRole">
							<span *ngIf="item.DigibankAgency?.name">{{item.DigibankAgency?.name}}</span>
							<span *ngIf="item.DigibankAgency?.name && item.jobRole"> - </span>
							<span *ngIf="item.jobRole">{{item.jobRole}}</span>
						</p>
					</div>
				</ng-template>
			</form-select>

			<form-select 
				label="{{ 'EVENT.LOAN_LOCATION' | translate }}" [formControl]="eventForm.get('isLoanLocation') | cast" [items]="isLoanLocationOptions" bindValue="value" bindLabel="label" [multiple]="false" position="top">
			</form-select>

            
			<div class="_color-selector">
				<form-label label="{{ 'EVENT.COLOR'| translate }}" [formControl]="eventForm.get('color') | cast"></form-label>
				<div class="_colors">
					<div 
						class="_color" 
						*ngFor="let color of colors" 
						[ngStyle]="{'background-color': color.hex}" 
						[ngClass]="{'_selected': eventForm.get('color').value === color.hex}" 
						(click)="toggleColorSelection(color.hex)" 
						tooltip="{{color.name}}"
						[options]="{ 'hide-delay': 0, theme: 'light' }">
					</div>
				</div>
				<form-validation-error [control]="eventForm.get('color') | cast"></form-validation-error>
			</div>	
			
			
			<!-- PUBLIC LIST -->
			<p class="_title" [translate]="'EVENT.PUBLIC.TITLE'"></p>	
			<p class="_subtitle" [translate]="'EVENT.PUBLIC.SUBTITLE'"></p>
		
			<div class="_checkbox-container">
				<ion-checkbox color="success" [formControl]="eventForm.get('isPublicEvent') | cast" ></ion-checkbox>
				<ion-label [translate]="'EVENT.PUBLIC.PUBLIC_EVENT'"></ion-label>
			</div>

			@if (eventForm.get('isPublicEvent').value) {
				<div class="_checkbox-container">
					<ion-checkbox color="success" [formControl]="eventForm.get('hasPublicReservation') | cast" ></ion-checkbox>
					<ion-label [translate]="'EVENT.PUBLIC.HAS_PUBLIC_RESERVATION'"></ion-label>
				</div>

				<form-textarea label="{{ 'EVENT.PUBLIC.PUBLIC_INFO' | translate }}" [formControl]="eventForm.get('publicInfo') | cast"></form-textarea>

				<form-select 
					label="{{ 'EVENT.PUBLIC.UIT_DATABASE_LABELS' | translate }}" 
					[formControl]="eventForm.get('uitDatabaseLabels') | cast" 
					[items]="uitDatabaseLabels" 
					bindValue="name" 
					bindLabel="name" 
					[multiple]="true"
					position="top"
					>
				</form-select>
			}

			<!-- COMMUNICATION TEMPLATES -->
			@if (eventForm.get('attendanceType').value && eventForm.get('attendanceType').value !== EventAttendanceType.WalkIn) {

				<div class="_communication-templates-container">
					<p class="_title" [translate]="'EVENT.COMMUNICATION_TEMPLATES.TITLE'"></p>	
					<p class="_subtitle" [translate]="'COMMUNICATION_TEMPLATE.DISCLAIMER'"></p>
					<p class="_subtitle" [translate]="'EVENT.COMMUNICATION_TEMPLATES.SUBTITLE'"></p>	

					<form-select 
						label="{{ 'EVENT.COMMUNICATION_TEMPLATES.CREATE_RESERVATION' | translate }}" 
						[formControl]="eventForm.get('CommunicationTemplateForCreateReservationIds') | cast" 
						[items]="customCommunicationTemplates" 
						bindValue="id" 
						[multiple]="true"
						position="top"
						[template]="customCommunicationTemplate"
						>
						<ng-template let-item #customCommunicationTemplate> 
							<div class="_communication-template">
								<p>{{item.customName}}</p>
								<p class="_communication-template-info">
									{{'COMMUNICATION_CHANNELS.' + item.channel | uppercase | translate}} {{'TO' | translate}} {{'COMMUNICATION_ENDPOINTS.' + item.endpoint | uppercase | translate | lowercase}}
								</p>
							</div>
						</ng-template>
					</form-select>

					<form-select 
						label="{{ 'EVENT.COMMUNICATION_TEMPLATES.UPDATE_RESERVATION' | translate }}" 
						[formControl]="eventForm.get('CommunicationTemplateForUpdateReservationIds') | cast" 
						[items]="customCommunicationTemplates" 
						bindValue="id" 
						[multiple]="true"
						position="top"
						[template]="customCommunicationTemplate"
						>
						<ng-template let-item #customCommunicationTemplate> 
							<div class="_communication-template">
								<p>{{item.customName}}</p>
								<p class="_communication-template-info">
									{{'COMMUNICATION_CHANNELS.' + item.channel | uppercase | translate}} {{'TO' | translate}} {{'COMMUNICATION_ENDPOINTS.' + item.endpoint | uppercase | translate | lowercase}}
								</p>
							</div>
						</ng-template>
					</form-select>

					<form-select 
						label="{{ 'EVENT.COMMUNICATION_TEMPLATES.CANCEL_RESERVATION' | translate }}" 
						[formControl]="eventForm.get('CommunicationTemplateForCancelReservationIds') | cast" 
						[items]="customCommunicationTemplates" 
						bindValue="id" 
						[multiple]="true"
						position="top"
						[template]="customCommunicationTemplate"
						>
						<ng-template let-item #customCommunicationTemplate> 
							<div class="_communication-template">
								<p>{{item.customName}}</p>
								<p class="_communication-template-info">
									{{'COMMUNICATION_CHANNELS.' + item.channel | uppercase | translate}} {{'TO' | translate}} {{'COMMUNICATION_ENDPOINTS.' + item.endpoint | uppercase | translate | lowercase}}
								</p>
							</div>
						</ng-template>
					</form-select>

					<form-select 
						label="{{ 'EVENT.COMMUNICATION_TEMPLATES.REMIND_RESERVATION' | translate }}" 
						[formControl]="eventForm.get('CommunicationTemplateForRemindReservationIds') | cast" 
						[items]="customCommunicationTemplates" 
						bindValue="id" 
						[multiple]="true"
						position="top"
						[template]="customCommunicationTemplate"
						>
						<ng-template let-item #customCommunicationTemplate> 
							<div class="_communication-template">
								<p>{{item.customName}}</p>
								<p class="_communication-template-info">
									{{'COMMUNICATION_CHANNELS.' + item.channel | uppercase | translate}} {{'TO' | translate}} {{'COMMUNICATION_ENDPOINTS.' + item.endpoint | uppercase | translate | lowercase}}
								</p>
							</div>
						</ng-template>
					</form-select>
				</div>

			}
		
		</form>
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
		<ng-container *ifUserHasPermissions="[UserPermissions.WriteEvents]">
			<ng-container *ngIf="action !== Action.CREATE; else create">
				<button 
					type="button" 
					class="_button _delete-button" 
					[translate]="(eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.DELETE_UNKNOWN_TYPE' : 'EVENT.LESSONS.DELETE_ALL')" 
					(click)="deleteEvent()"
				></button>			
				<button class="_button _save-button" [translate]="(eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.UPDATE' : 'EVENT.LESSONS.UPDATE_ALL')" (click)="updateEvent()"></button>
			</ng-container>
			<ng-template #create>
				<button class="_button _save-button" [translate]="(eventForm.get('attendanceType').value !== EventAttendanceType.Lessons ? 'EVENT.CREATE' : 'EVENT.LESSONS.CREATE_ALL')" (click)="createEvent()"></button>
			</ng-template>
		</ng-container>
		<button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="close()"></button>
	</ng-container>

</modal-component>